import React from 'react';
import { Button, Container, Grid, Typography, Card, CardContent, Box } from '@mui/material';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import CheckCircleOutlineOutlined from '@mui/icons-material/CheckCircleOutlineOutlined';

const PricingSection = ({ t, navigate, currentLang }) => (
    <Box sx={{ padding: 4, pb: 15, mt: -10, background: '#8c52ff', borderTopLeftRadius: 75, borderTopRightRadius: 75 }}>
        <Container>
            <Grid container>
                <Grid item xs={12}>
                    <Typography variant="h3" color='#fff' sx={{ fontSize: { xs: '2.125rem', sm: '3rem' }, mb: 5, fontWeight: 'bold', textAlign: 'center' }}>
                        {t('pricing_title')}
                    </Typography>
                </Grid>

                <Grid item xs={12}>
                    <Grid container spacing={4} justifyContent="center">
                        {[
                            {
                                id: 'basic',
                                name: "plan_basic",
                                price: "6,00 €",
                                benefits: [
                                    { text: "plan_basic_benefit1", hasBenefit: true },
                                    { text: "plan_basic_benefit2", hasBenefit: true },
                                    { text: "plan_basic_benefit3", hasBenefit: false }
                                ]
                            },
                            {
                                id: 'premium',
                                name: "plan_exclusive",
                                price: "9,00 €",
                                benefits: [
                                    { text: "plan_exclusive_benefit1", hasBenefit: true },
                                    { text: "plan_exclusive_benefit2", hasBenefit: true },
                                    { text: "plan_exclusive_benefit3", hasBenefit: true }
                                ]
                            }
                        ].map((plan, index) => (
                            <Grid item xs={12} sm={6} md={5} lg={4} display='flex' justifyContent='center' key={index}>
                                <Card sx={{
                                    background: 'rgb(43, 19, 146, 0.4)',
                                    borderRadius: 4,
                                    width: '100%',
                                    border: (plan.id === 'premium' ? '2px solid #fd66c4' : 0),
                                    overflow: 'visible'
                                }}>
                                    <CardContent sx={{ p: 0 }}>
                                        <Box sx={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                            alignItems: 'flex-end',
                                            justifyContent: 'space-between',
                                            position: 'relative',
                                            px: 4,
                                            py: 3,
                                            width: '100%'
                                        }}>
                                            <Box>
                                                <Typography color='#fd66c4' component='p' fontWeight='bold' variant="h6">{t(plan.name)}</Typography>
                                                <Typography color='white' component='p' fontWeight='bold' variant="h3" sx={{ fontSize: { xs: '2rem', md: '2.75rem', lg: '3rem' } }}>{plan.price}</Typography>
                                            </Box>
                                            <Box
                                                alt={`Plan ${plan.name}`}
                                                component='img'
                                                src={require(`../../assets/img/plan-${plan.id}.webp`)}
                                                sx={{ height: 'fit-content', width: { xs: 40, lg: 50 } }}
                                            />
                                            {plan.id === 'premium' &&
                                                <Typography
                                                    borderRadius={10}
                                                    color="white"
                                                    component='p'
                                                    fontWeight='bold'
                                                    px={2}
                                                    textAlign='center'
                                                    variant="body1"
                                                    sx={{
                                                        background: '#fd66c4',
                                                        position: 'absolute',
                                                        left: '50%',
                                                        top: -14,
                                                        transform: 'translateX(-50%)',
                                                        width: 'max-content'
                                                    }}
                                                >
                                                    {t('pricing_plan_most_chosen')}
                                                </Typography>
                                            }

                                        </Box>
                                        <Box sx={{ px: 4, width: '100%' }}>
                                            <ul style={{ listStyle: 'none', padding: 0 }}>
                                                {plan.benefits.map((benefit, i) => (
                                                    <li
                                                        key={i}
                                                        style={{
                                                            alignItems: 'center',
                                                            color: 'white',
                                                            display: 'flex',
                                                            fontSize: '1.1rem',
                                                            fontWeight: 'bold',
                                                            paddingBottom: 8
                                                        }}>
                                                        {benefit.hasBenefit ?
                                                            <CheckCircleOutlineOutlined style={{ color: 'white', marginRight: 8 }} /> :
                                                            <CancelOutlinedIcon style={{ color: 'white', marginRight: 8 }} />}
                                                        {t(benefit.text)}
                                                    </li>
                                                ))}
                                            </ul>
                                            <Box display='flex' justifyContent='center'>
                                                <Button
                                                    onClick={() => navigate(`/${currentLang}/create`, { state: { planId: plan.id } })}
                                                    variant="contained"
                                                    color="primary"
                                                    sx={{ boxShadow: 'none', width: '100%', px: 0 }}
                                                >
                                                    {t('pricing_cta')}
                                                </Button>
                                            </Box>
                                        </Box>
                                    </CardContent>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>

                </Grid>
            </Grid>

        </Container>
    </Box>
);

export default PricingSection;
